module.exports = __webpack_public_path__ + "img/type3.b16ef357.png";